import { FaLinkedin, FaTwitter, FaYoutube } from 'react-icons/fa';
import type { IMenuGroup, IMenuItem, ISocialItem } from '../types';

export const menuGroups: IMenuGroup[] = [
  {
    heading: 'LANDING.FOOTER.COMPANY',
    items: [
      {
        id: 'who-we-are',
        label: 'LANDING.FOOTER.ABOUT_US',
        href: 'https://www.mbecorporate.com/#about',
        target: '_blank',
      },
      {
        id: 'our-people',
        label: 'LANDING.FOOTER.OUR_PEOPLE',
        href: 'https://www.mbecorporate.com/#people',
        target: '_blank',
      },
      {
        id: 'our-brands',
        label: 'LANDING.FOOTER.BRAND_IDENTITY',
        href: 'https://www.mbecorporate.com/#brands',
        target: '_blank',
      },
    ],
  },
  {
    heading: 'LANDING.FOOTER.SUPPORT',
    items: [
      {
        id: 'contact-us',
        label: 'LANDING.FOOTER.INFO_REQUEST',
        href: 'https://www.mbecorporate.com/contact-us/',
        target: '_blank',
      },
    ],
  },
];

export const socials: ISocialItem[] = [
  {
    id: 'youtube',
    label: 'youtube',
    href: 'https://www.youtube.com/channel/UCCL7CaBuCAFshrHfB88BQCQ',
    icon: FaYoutube,
  },
  {
    id: 'twitter',
    label: 'twitter',
    href: 'https://twitter.com/WorldwideMBE',
    icon: FaTwitter,
  },
  {
    id: 'linkedin',
    label: 'linkedin',
    href: 'https://www.linkedin.com/company/mail-boxes-etc--worldwide/',
    icon: FaLinkedin,
  },
];

export const getLegalInfos = (language: string): IMenuItem[] => {
  const supportedLanguages = ['en', 'es', 'fr', 'it'];
  const defaultLanguage = 'en';
  const languageCode = language.split('-')[0];

  const filePrefix = !supportedLanguages.includes(languageCode) ? defaultLanguage : languageCode;

  return [
    {
      id: 'legal-notes',
      label: 'LANDING.FOOTER.LEGAL_NOTES',
      href: `/files/legal/legal_notes_${filePrefix}.pdf`,
    },
    {
      id: 'privacy',
      label: 'LANDING.FOOTER.PRIVACY',
      href: `/files/legal/privacy_information_${filePrefix}.pdf`,
    },
    {
      id: 'cookie-policy',
      label: 'LANDING.FOOTER.COOKIE_POLICY',
      href: `/files/legal/cookie_policy_${filePrefix}.pdf`,
    },
    {
      id: 'terms-of-use',
      label: 'LANDING.FOOTER.TERMS_OF_USE',
      href: `/files/legal/terms_of_use_${filePrefix}.pdf`,
    },
    {
      id: 'general-terms-and-conditions',
      label: 'LANDING.FOOTER.GENERAL_TERMS_AND_CONDITIONS',
      href: `/files/legal/general_terms_and_conditions_${filePrefix}.pdf`,
    },
  ];
};
